// ============================================================================
// useMarketOperator — ЕСТЬ ЛИ У ПОЛЬЗОВАТЕЛЯ ДОСТУП К ОПЕРАТОРСКОМУ ЭКРАНУ.
//
// Источник истины — роли из сессии (JWT). Серверные гейты (internal/markettake)
// остаются последним рубежом: клиентская проверка только показывает экран.
// Администратор видит операторский экран всегда (он управляет базой).
// Нормализация ролей — lib/marketRoles (единый источник для UI и слоя данных).
// ============================================================================

import { useAuthStore } from '@/store/authStore';
import {
  marketOperatorAccess,
  type MarketOperatorAccess,
} from '@/lib/marketRoles';

export { marketOperatorAccess } from '@/lib/marketRoles';
export type { MarketOperatorAccess } from '@/lib/marketRoles';

export function useMarketOperator(): MarketOperatorAccess {
  const user = useAuthStore((s) => s.user);
  return marketOperatorAccess(user?.roles);
}
